import React, {
    useContext, useCallback, useState, useMemo, useEffect
} from 'react';
import _ from 'lodash';
import { BreakpointTrackerContext } from '@jutro/layout';
import { InputField, CurrencyField, DropdownSelectField, RadioButtonField } from '@jutro/components';
import { Loader, ModalNextProvider } from '@jutro/components';
import { WizardPage, wizardProps } from 'gw-portals-wizard-react';
import { useAuthentication } from 'gw-digital-auth-react';
import { useDependencies } from 'gw-portals-dependency-react';
import { useValidation } from 'gw-portals-validation-react';
import { ServiceManager } from '@jutro/services';
import { GatewayDocumentService } from 'gw-capability-gateway-document';
import { readViewModelValue } from 'gw-jutro-adapters-react';
import { ViewModelForm, ViewModelServiceContext } from 'gw-portals-viewmodel-react';
import metadata from './PaymentDetailsPage.metadata.json5';
import messages from './PaymentDetailsPage.messages';
import styles from './PaymentDetailsPage.module.scss';
import { QuestionSetComponent } from 'gw-components-platform-react';
import { RadioColumn } from '@jutro/datatable';
import { messages as commonMessages } from 'gw-platform-translations';

const PAYMENT_METHOD = {
    bank: 'wire',
    credit: 'creditcard'
};
const BLOCKS_BIND = 'BlocksBind';
const BLOCKS_QUOTES = ['BlocksQuote', 'BlocksQuoteRelease'];

class AddDownPaymentBtnLabel {
    label;
    constructor(label) {
        const instance = this.constructor.instance
        if (instance) {
            return instance
        }
        this.constructor.instance = this;
        this.label = label
    }

    setLabel(label) {
        this.label = label;
    }
    getLabel() {
        return this.label;
    }

}

/* eslint-disable no-param-reassign */
function initialiseVM(submissionVM) {
    let paymentDetailsValue = submissionVM?.bindData?.paymentDetails?.value
    paymentDetailsValue = submissionVM.bindData.paymentDetails && submissionVM.bindData.paymentDetails.value ? submissionVM.bindData.paymentDetails.value : {};
}
/* eslint-enable no-param-reassign */

function PaymentDetailsPage(props) {
    const { wizardData: submissionVM, updateWizardData, wizardSnapshot, underwritingIssues, filterUWIssuesInCustomOffering } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const [isLoading, updateIsLoading] = useState(false);
    const [isVMInitialised, updateIsVMInitialised] = useState(false);
    const { authHeader, checkPermission } = useAuthentication();
    const { LoadSaveService } = useDependencies('LoadSaveService');
    const [hasRetrievedPaymentPlans, updateHasRetrievedPaymentPlans] = useState(false);
    const { isComponentValid, registerComponentValidation } = useValidation('PaymentDetailsPage');
    const viewModelService = useContext(ViewModelServiceContext);
    const [showSigningPackage, setShowSigningPackage] = useState(false);
    const localeService = ServiceManager.getService('locale-service');
    const [paymentList, updatePaymentList] = useState([]);
    const [addCreditCardInstrument, updateAddCreditCardInstrument] = useState(false);
    const [addBankInstrument, updateAddBankInstrument] = useState(false);
    const [iframeUrl, updateiFrameUrl] = useState('');
    const [loadIframeUrl, updateLoadIframeUrl] = useState(false);
    const [monURL, updateMonURL] = useState('');
    const [cardError, updateCardError] = useState('');
    const [token, updateToken] = useState('');
    const [instituteNumber, setInstituteNumber] = useState("");
    const [instituteList, updateInstituteList] = useState([]);
    const [selectedBankValue, updateSelectedBankValue] = useState('');
    const [validationIssues, updateValidationIssues] = useState([]);
    const [ispaymentIssue, updateIsPaymentIssue] = useState(false);
    const [avgMonthlypremium, updateAvgMonthlypremium] = useState('');
    const [totalpremium, updateTotalpremium] = useState('');
    const DocumentPageService = {
        downloadDocument: GatewayDocumentService.downloadDocument
    };
    let isMonerisSubmitted = false;
    const LOB_PATH = {
        PersonalAuto: 'lobData.personalAuto.preQualQuestionSets.children[0].value',
        Homeowners: 'lobData.homeowners.preQualQuestionSets.children[0].value',
        HOPHomeowners: 'lobData.homeowners.preQualQuestionSets.children[0].value',
        BusinessOwners: 'lobData.businessOwners.preQualQuestionSets.children[0].value',
        BusinessAuto: 'lobData.businessAuto.preQualQuestionSets.children[0].value'
    };
    const lobCode = _.get(submissionVM.value, 'baseData.productCode');

    const BLOCKS_QUOTES = ['BlocksQuote', 'BlocksQuoteRelease'];
    const BLOCKS_BIND = 'BlocksBind';

    useEffect(() => {
        if (!isVMInitialised) {
            initialiseVM(submissionVM);
            
            
            if(submissionVM.value.errorsAndWarnings.validationIssues && submissionVM.value.errorsAndWarnings.validationIssues.issues){
                const validationIssues = _.filter(submissionVM.value.errorsAndWarnings.validationIssues.issues, {type: 'error'});  
                const paymentIssues = _.filter(validationIssues, (error) => {
                    return error.reason.includes('payment plan') || error.reason.includes('billing') || error.reason.includes('Payment')
                }).length > 0;
                updateValidationIssues(validationIssues);           
                updateIsPaymentIssue((paymentIssues.length > 0 && paymentIssues.length == validationIssues.length));
            }
            
            LoadSaveService.getPaymentInstrumentList_EY(submissionVM.value, authHeader)
                .then((list) => {
                    // if(submissionVM.bindData.paymentDetails.billingMethod_EY && submissionVM.bindData.paymentDetails.paymentMethod
                    //     && submissionVM.bindData.paymentDetails.billingMethod_EY.value === 'Direct Bill' && !submissionVM.bindData.paymentDetails.paymentMethod.value){
                    //     submissionVM.bindData.paymentDetails.paymentMethod.value = 'Invoiced';
                    // }
                    for(var i=0; i<list.length; i++){
                        paymentList.push(list[i]);
                    }
                    if(submissionVM.bindData.paymentDetails.billingMethod_EY.value === 'Direct Bill' && submissionVM.baseData.initiatedBy_EY.value === 'BMS Initiated Submission' && list.filter(payment => payment.paymentMethod === 'ach').length > 0){
                        submissionVM.bindData.paymentDetails.paymentMethod.value = 'Preauthorized Bank Account';
                    }
                    updateIsVMInitialised(true);
                })
                .catch((error) => {
                    ModalNextProvider.showAlert({
                        title: messages.modelError,
                        message: messages.paymentListError,
                        status: 'error',
                        icon: 'mi-error-outline',
                        confirmButtonText: commonMessages.ok
                    }).catch(_.noop);
                    updateIsVMInitialised(true);
                });

        }
    }, [isVMInitialised, submissionVM, LoadSaveService, authHeader]);

    const paymentBtn = new AddDownPaymentBtnLabel("Add");

    const findBlockingPoint = (type) => {
            return underwritingIssues.some((offeringIssue) => {
                if (type === BLOCKS_BIND) {
                    return offeringIssue.currentBlockingPoint === BLOCKS_BIND;
                }
                return _.includes(BLOCKS_QUOTES, offeringIssue.currentBlockingPoint);
            });
    }

    const getUpdatedPremium =() => {
        const chosenQuoteData = submissionVM.quoteData.offeredQuotes.value.find(
            ({ publicID }) => publicID === submissionVM.bindData.chosenQuote.value
        );

        const monthlyAmount= _.get(chosenQuoteData, 'premium.monthlyPremium');
        const totalAmount= _.get(chosenQuoteData, 'premium.total');

        updateAvgMonthlypremium(monthlyAmount);
        updateTotalpremium(totalAmount);

        // return {
        //     monthlyAmount: _.get(chosenQuoteData, 'premium.monthlyPremium'),
        //     totalAmount: _.get(chosenQuoteData, 'premium.total')
        // };
    };

    const formatPaymentData = useCallback(() => {
        const paymentDetailsPath = 'bindData.paymentDetails';
        const paymentMethod = _.get(submissionVM, `${paymentDetailsPath}.paymentMethod.value`);

        if (paymentMethod === PAYMENT_METHOD.bank) {
            _.set(submissionVM, `${paymentDetailsPath}.creditCardData`, undefined);
        } else if (paymentMethod === PAYMENT_METHOD.credit) {
            _.set(submissionVM, `${paymentDetailsPath}.bankAccountData`, undefined);
        }

        return submissionVM.value;
    }, [submissionVM]);

    const handleNext = useCallback(async () => {   
        const isBlocksBind = submissionVM.errorsAndWarnings.underwritingIssues.value && submissionVM.errorsAndWarnings.underwritingIssues.value.some((offeringIssue) => {
            return offeringIssue.currentBlockingPoint === BLOCKS_BIND;            
        });

          if(isBlocksBind || (submissionVM.errorsAndWarnings.validationIssues.issues.value && submissionVM.errorsAndWarnings.validationIssues.issues.value.length > 0)){
            if(isBlocksBind){
            ModalNextProvider.showAlert({
                title: 'Warning',
                message: messages.modalWarning,
                status: 'warning',
                icon: 'mi-warning-outline',
                confirmButtonText: commonMessages.ok
            }).catch(_.noop);
            return false;
        }
    }
            const result = await ModalNextProvider.showConfirm({
                title: messages.brokerDeclaration,
                message: messages.confirmationOfSignAndDoc,
                status: 'success',
                icon: 'mi-error-outline',
                confirmButtonText: commonMessages.ok,
                cancelButtonText: commonMessages.no
            });
            if (result === 'cancel') {
                return false;
            }
            try {
                const onePaymentId = submissionVM.bindData.paymentPlans && submissionVM.bindData.paymentPlans.value ? submissionVM.bindData.paymentPlans.value.filter((i)=>{return i.name == "One Pay Plan"})[0].billingId : []
                if(submissionVM.bindData.paymentDetails.paymentMethod.value == "Preauthorized Bank Account"){
                    if(submissionVM.bindData.selectedPaymentPlan && submissionVM.bindData.selectedPaymentPlan.value == onePaymentId){
                    ModalNextProvider.showAlert({
                        title: messages.modelError,
                        message: messages.paymentMethodChangeError,
                        status: 'error',
                        icon: 'mi-error-outline',
                        confirmButtonText: commonMessages.ok
                    }).catch(_.noop);
                    return false;
                } else if (submissionVM.bindData.paymentDetails.selectedPaymentInstrument_EY.value === undefined || submissionVM.bindData.paymentDetails.selectedPaymentInstrument_EY.value == ''){
                    ModalNextProvider.showAlert({
                        title: messages.modelError,
                        message: messages.payUsingBAError,
                        status: 'error',
                        icon: 'mi-error-outline',
                        confirmButtonText: commonMessages.ok
                    }).catch(_.noop);
                    return false;
                }
                else {
                    submissionVM.value = await LoadSaveService.bindSubmission(formatPaymentData(), authHeader);
                }
            }
             else if(submissionVM.bindData.paymentDetails.paymentMethod.value == "Preauthorized Credit Card" && 
             (submissionVM.bindData.paymentDetails.selectedPaymentInstrument_EY.value === undefined ||submissionVM.bindData.paymentDetails.selectedPaymentInstrument_EY.value == '')){
                    ModalNextProvider.showAlert({
                        title: messages.modelError,
                        message: messages.payUsingCCError,
                        status: 'error',
                        icon: 'mi-error-outline',
                        confirmButtonText: commonMessages.ok
                    }).catch(_.noop);
                    return false; 
             } 
              else {
                    submissionVM.value = await LoadSaveService.bindSubmission(formatPaymentData(), authHeader);
                }
                updateWizardData(submissionVM);        
            
            } 
            catch(e) {
                return e;
            }
            return submissionVM;                
    }, [LoadSaveService, authHeader, formatPaymentData, submissionVM]);

    if (!hasRetrievedPaymentPlans && !isLoading) {
        const { quoteID, sessionUUID } = submissionVM.value;
        updateIsLoading(true);
        LoadSaveService.retrievePaymentPlans(quoteID, sessionUUID, authHeader)
            .then((paymentPlans) => {
                _.set(submissionVM, 'bindData.paymentPlans', paymentPlans);
                updateWizardData(submissionVM);
                updateHasRetrievedPaymentPlans(true);
            })
            .finally(() => {
                updateIsLoading(false);
            });
    }

    const hasPPVvehicle = () => {
        let ppvVehicleExist = false
        if(submissionVM.baseData.productCode == "BusinessAuto" && !_.isEmpty(submissionVM.lobData.businessAuto.coverables.vehicles)){
            ppvVehicleExist = submissionVM.lobData.businessAuto.coverables.vehicles.value.filter((v)=>{
                return v.vehicleType == "PrivatePassenger_EY"
             }).length ?   true :  false

        }
        return ppvVehicleExist
    }

    const handlePaymentOptionEyChange = useCallback(
        (value) => {
            submissionVM.bindData.paymentDetails.selectedPaymentInstrument_EY.value = "";
            _.set(submissionVM, 'bindData.paymentDetails.paymentMethod', value);
                updateAddBankInstrument(false);
                updateAddCreditCardInstrument(false);
            
                if(submissionVM.baseData.periodStatus.value.code !== 'Draft') {
                    let monthlyPaymentId = submissionVM.bindData.paymentPlans && submissionVM.bindData.paymentPlans.value ? submissionVM.bindData.paymentPlans.value.filter((i)=>{return i.name == "Monthly Plan"}) : []
                    monthlyPaymentId = monthlyPaymentId.length > 0 ? monthlyPaymentId[0].billingId : '';
                    if( !hasPPVvehicle() && (submissionVM.bindData.paymentDetails.billingMethod_EY.value === "Direct Bill" && value == "Invoiced") && (submissionVM.bindData.selectedPaymentPlan && submissionVM.bindData.selectedPaymentPlan.value == monthlyPaymentId )){
                        _.set(submissionVM, 'bindData.selectedPaymentPlan', '');
                    }
                }

            /*if (submissionVM.bindData.paymentDetails.paymentMethod && submissionVM.bindData.paymentDetails.paymentMethod.value  === 'Preauthorized Bank Account') {
                if(submissionVM.bindData.paymentDetails.bankAccountData.value === undefined){
                    submissionVM.bindData.paymentDetails.bankAccountData.value = {};
                }
                if(submissionVM.bindData.paymentDetails.creditCardData.value){
                    submissionVM.bindData.paymentDetails.creditCardData.value = undefined;
                }
            } else if (submissionVM.bindData.paymentDetails.paymentMethod  && submissionVM.bindData.paymentDetails.paymentMethod.value === 'Preauthorized Credit Card') {
                if(submissionVM.bindData.paymentDetails.creditCardData.value === undefined){
                    submissionVM.bindData.paymentDetails.creditCardData.value = {};
                }
                if(submissionVM.bindData.paymentDetails.bankAccountData.value){
                    submissionVM.bindData.paymentDetails.bankAccountData.value = undefined;
                }
            }*/
            submissionVM.bindData.paymentDetails.bankAccountData.value = undefined;
            submissionVM.bindData.paymentDetails.creditCardData.value = undefined;
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData]
    );

    const handleBillingOptionChange = useCallback(
        (value) => {
            _.set(submissionVM, 'bindData.paymentDetails.billingMethod_EY', value);
            const onePaymentId = submissionVM.bindData.paymentPlans && submissionVM.bindData.paymentPlans.value ? submissionVM.bindData.paymentPlans.value.filter((i)=>{return i.name == "One Pay Plan"})[0].billingId : []
            if(value == "Agency Bill" ){
                _.set(submissionVM, 'bindData.selectedPaymentPlan', onePaymentId);
               //_.set(submissionVM, 'bindData.paymentDetails.withdrawDay_EY', '');
            }
            updateIsLoading(true);
            LoadSaveService.updateQuotedSubmissionWithLOBData(submissionVM.value, authHeader)
                .then((response) => {

                    const chosenQuoteData = response.quoteData.offeredQuotes.find(
                        ({ publicID }) => publicID === response.bindData.chosenQuote
                    );
                    const updatedtotalAmount= _.get(chosenQuoteData, 'premium.total');
                    updateIsLoading(false);
                    if(updatedtotalAmount.amount !== totalpremium.amount){
                        ModalNextProvider.showAlert({
                            title: 'Info',
                            message: messages.premiumUpdatedNotification,
                            status: 'info',
                            icon: 'mi-error-outline',
                            confirmButtonText: commonMessages.ok
                        }).catch(_.noop);
                        updateIsLoading(false);
                    }
                    submissionVM.value = response;
                    
                    updateWizardData(submissionVM);
                })
                .catch((error) => {
                    ModalNextProvider.showAlert({
                        title: messages.modelError,
                        message: messages.billingMethodChangeError,
                        status: 'error',
                        icon: 'mi-error-outline',
                        confirmButtonText: commonMessages.ok
                    }).catch(_.noop);
                    updateIsLoading(false);
                });
        },
        [submissionVM, updateWizardData]
    );

    const getBillingAvailableValues = useCallback(() => {
        const billingMethodEY = _.get(submissionVM, 'bindData.paymentDetails.supportedMethods_EY.value');
        return billingMethodEY != undefined ? billingMethodEY.map((v) => {
            return { code: v, name: v }
        }) : [{ code: 'DirectBill', name: 'DirectBill' }];
    }, [submissionVM]);

    const getPaymentMethodList = useCallback(() => {
        let paymentMethodEY = _.get(submissionVM, 'bindData.paymentDetails.paymentMethodList_EY.value');
        if(submissionVM.baseData.periodStatus.value.code !== 'Draft') {
            let monthlyPaymentId = submissionVM.bindData.paymentPlans ? submissionVM.bindData.paymentPlans.value.filter((i)=>{return i.name == "Monthly Plan"}) : []
            monthlyPaymentId = monthlyPaymentId.length > 0 ? monthlyPaymentId[0].billingId : '';

        if(!_.isUndefined(paymentMethodEY) && (submissionVM.bindData.selectedPaymentPlan && submissionVM.bindData.selectedPaymentPlan.value == monthlyPaymentId )){
            paymentMethodEY = paymentMethodEY.filter((pm) => {return pm !== "Invoiced"})
        }
    }
        return paymentMethodEY != undefined ? paymentMethodEY.map((v) => {
            return { code: v, name: v }
        }) : [{ code: 'invoice', name: 'invoice' }];
    }, [submissionVM]);

    //~ Down payment code changes  start

    const onValueChange = useCallback((value, item, prop) => {
        const index = submissionVM.bindData.paymentDetails.downPayment_EY.value.indexOf(item.value);
        const path = `bindData.paymentDetails.downPayment_EY.children.${index}.${prop.dataPath}`;
        const newSubmissionVM = viewModelService.clone(submissionVM);
        _.set(newSubmissionVM, path, value);
        updateWizardData(newSubmissionVM);
    }, [submissionVM]
    );

    const handleValueChange = useCallback((value, item, prop) => {
        submissionVM.bindData.paymentDetails.selectedPaymentInstrument_EY.value = value;
        const newSubmissionVM = viewModelService.clone(submissionVM);
        updateWizardData(newSubmissionVM);
    }, [submissionVM]
    );

    const handleInstitueValueChange = useCallback((value, item, prop) => {
        /*submissionVM.bindData.paymentDetails.selectedPaymentInstrument_EY.value = value;
        const newSubmissionVM = viewModelService.clone(submissionVM);
        updateWizardData(newSubmissionVM);*/
        updateSelectedBankValue(value);
        var res = value.split("-");
        submissionVM.bindData.paymentDetails.bankAccountData.instituteNumber_EY.value = res[0];
        submissionVM.bindData.paymentDetails.bankAccountData.instituteName_EY.value = res[1];
        updateWizardData(submissionVM);
    }, [submissionVM]
    );

    const deleteDownPayment = (event, index) => {
        submissionVM.bindData.paymentDetails.downPayment_EY.value.splice(index, 1);
        const newSubmissionVM = viewModelService.clone(submissionVM);
        updateWizardData(newSubmissionVM);
        paymentBtn.setLabel("Save");

    }

    const editDownPayment = (event, index) => {
        submissionVM.bindData.paymentDetails.downPayment_EY.value[index].isEdit = true;
        const newSubmissionVM = viewModelService.clone(submissionVM);
        updateWizardData(newSubmissionVM);
        paymentBtn.setLabel("Save");

    }

    const getWithdrawalDayOfMonth = () => {
        const dayOfMonth = [];
        for (let i = 1; i <= 31; i++) {
            dayOfMonth.push({ code: i, name: i });
        }
        return dayOfMonth;
    }
    const getDataTableCell = (item, index, props) => {
        const path = props.path;
        const value = item[path].value;
        const readOnly = !(item.isEdit.value);
        const disabled = false;
        if (path == 'paymentInstrument_EY') {
            const availableValues = submissionVM.bindData.downPaymentOptions_EY.value.map((i) => {
                return { code: i, name: i }
            });
            // const readOnly =false;
            //
            return (
                <DropdownSelectField
                    className={styles.tableField}
                    id={index + path}
                    onValueChange={onValueChange}
                    dataType="string"
                    model={item}
                    dataPath={path}
                    value={value}
                    availableValues={availableValues}
                    readOnly={readOnly}
                    disabled={disabled}
                />
            )
        }
        else if (path == 'reference_EY') {
            return (
                <InputField
                    dataType="string"
                    id={index + path}
                    onValueChange={onValueChange}
                    model={item}
                    dataPath={path}
                    value={value}
                    readOnly={readOnly}
                    showRequired={true}
                />
            )
        }
        else if (path == 'amount_EY') {
            return (
                <CurrencyField
                    id={index + path}
                    onValueChange={onValueChange}
                    model={item}
                    dataPath={path}
                    value={value}
                    readOnly={readOnly}
                    showRequired={true}
                    defaultCurrency={localeService.getDefaultCurrencyCode()}
                />
            )
        }


    };

    const generateDataForRadioButton = (item) => {
        return {
            name: item.displayName,
            code: item.publicID
        };
    };

    const generateDataForInstitureRadioButton = (item) => {
        return {
            name: item.bankName,
            code: item.institutionNumber+'-'+item.bankName
        };
    };

    const getPayUsingDataTableCell = (item, index, props) => {
        const path = props.path;
        var selectedPaymentPlan = item.publicID;
        if (path == 'selectedPaymentInstrument_EY') {
            return (
                <RadioColumn
                    id={index + path}
                    textAlign="left"
                    header={item.displayName}
                    option={generateDataForRadioButton}
                    cellClassName={styles.paymentListTableCell}
                    value={selectedPaymentPlan}
                    onValueChange={handleValueChange}
                />
            )
        }
        else if (path == 'displayName') {
           return (
                <InputField
                    dataType="string"
                    id={index + path}
                    value={item.displayName}
                    readOnly={true}
                />
           )
       }
        else if (path == 'instituteName') {
           return (
                <InputField
                    dataType="string"
                    id={index + path}
                    value={item.bankName}
                    readOnly={true}
                />
           )
       }
        else if (path == 'instituteNumber') {
           return (
                <InputField
                    dataType="string"
                    id={index + path}
                    value={item.institutionNumber}
                    readOnly={true}
                />
           )
       }


    };

    const addDownPaymentItem = () => {

        if (paymentBtn.getLabel() === 'Save') {
            updateIsLoading(true);
            LoadSaveService.updateQuotedSubmissionWithPaymentData(submissionVM.value, authHeader)
                .then((response) => {
                    const newSubmissionVM = viewModelService.clone(submissionVM);
                    _.set(newSubmissionVM, 'bindData.paymentDetails.downPayment_EY', response.bindData.paymentDetails.downPayment_EY);
                    updateWizardData(newSubmissionVM);
                })
                .finally(() => {
                    paymentBtn.setLabel('Add');
                    updateIsLoading(false);
                });
        } else {
            const packageItem = {
                amount_EY: "",
                isValidationRequired: true,
                paymentInstrument_EY: "",
                reference_EY: "",
                isEdit: true,
            }
            paymentBtn.setLabel("Save");
            submissionVM.bindData.paymentDetails.downPayment_EY.value.push(packageItem);
            updateWizardData(submissionVM);
        }
    };
     /**Validate card */
    const doMonerisSubmit  = () => {
        if (!(submissionVM.bindData.paymentDetails.creditCardData.aspects.valid && submissionVM.bindData.paymentDetails.creditCardData.aspects.subtreeValid)) {
            ModalNextProvider.showAlert({
                title: messages.creditCardError,
                message: messages.creditCardEmptyError,
                status: 'error',
                icon: 'mi-error-outline',
                confirmButtonText: commonMessages.ok
            }).catch(_.noop);
            return;
        }
        isMonerisSubmitted = true;
        var monFrameRef = document.getElementById('monerisFrame').contentWindow;
       // monFrameRef.postMessage('tokenize','https://esqa.moneris.com/HPPtoken/index.php');
        monFrameRef.postMessage('tokenize', monURL);
        if (window.addEventListener)
            {
                window.addEventListener ("message", respMsg, false);
            }
        else
            {
                if (window.attachEvent)
                {
                    window.attachEvent("onmessage", respMsg);
                }
            }
        return false;
    };

    /**Function called at iFrame response */
    var respMsg = function(e) {
        if (!(submissionVM.bindData.paymentDetails.creditCardData.aspects.valid && submissionVM.bindData.paymentDetails.creditCardData.aspects.subtreeValid)) {
            return;
        }
        if(!isMonerisSubmitted) {
            return;
        }
        isMonerisSubmitted = false;
        var respData = eval("(" + e.data + ")");
        updateCardError('');
        updateToken('');
        if(respData.responseCode[0] =='001'){
            /**Todo change below to scope hide and show */
            /*document.getElementById("validateButton").style.display = 'none';
            document.getElementById("monerisFrame").style.display = 'none';*/
            updateLoadIframeUrl(false);
            updateAddCreditCardInstrument(false);
            //updateToken(respData.dataKey);
            submissionVM.bindData.paymentDetails.creditCardData.token_EY.value = respData.dataKey;
            updateAddCreditCardInstrument(false);
           // $scope.token = 'ot-Y70epLUoSub5puf3HQ9nYXsK5';
           // submissionVM.bindData.paymentDetails.creditCardData.token_EY.value = token;
            addCreditCardPaymentInstrument();
        }
        var errorDesc = "";
            for (var i = 0; i < respData.responseCode.length; i++) {
                if (respData.responseCode[i] != "") {
                    switch(respData.responseCode[i]) {
                        case "940":
                        case "941":
                        case "942":
                            errorDesc = errorDesc + "Validation failed. Please retry after checking the card details";
                            break;
                        case "943":
                            errorDesc = errorDesc + "Card Number is invalid";
                            break;
                        case "944":
                            errorDesc = errorDesc + "Invalid expiration date (mmyy, must be current month or in the future)";
                            break;
                        case "945":
                            errorDesc = errorDesc + "Invalid CVV data (not 3 digits)";
                            break;
                        default:
                    }
                    if (respData.responseCode.length > 1) {
                        errorDesc = errorDesc + " ; "	;
                    }
                    if (respData.responseCode.length >= 1 && errorDesc != "") {
                        updateAddCreditCardInstrument(false);
                        ModalNextProvider.showAlert({
                            title: messages.creditCardError,
                            message: errorDesc,
                            status: 'error',
                            icon: 'mi-error-outline',
                            confirmButtonText: commonMessages.ok
                        }).catch(_.noop);
                        /*$scope.resetPaymentInstrument(null);
                        $scope.addCreditCardInstrument = false;
                        const description = $translate(
                                                        'quoteandbind.controllers.PaymentDetailsCtrl.Payment Add Failure',
                                                        {paymentError: errorDesc}
                                                    );
                        ModalService.showError(
                            'quoteandbind.controllers.PaymentDetailsCtrl.Payment Status',
                            description
                        );*/
                    }
                }
            }
            /**Todo display error in popup, add hide and show */
       // $scope.cardError = errorDesc;
       // $scope.token = respData.dataKey;
    };
    

     /**Add Credit PaymentInstrument */
    const addCreditCardPaymentInstrument  = () => {
        if (!(submissionVM.bindData.paymentDetails.creditCardData.aspects.valid && submissionVM.bindData.paymentDetails.creditCardData.aspects.subtreeValid)) {
            return;
        }
        LoadSaveService.addCreditPaymentInstrument_EY(submissionVM.value, submissionVM.bindData.paymentDetails.value, authHeader).then(list => {
            //paymentList = [];
            updatePaymentList(list);
            for(var i=0; i<list.length; i++){
                //paymentList.push(list[i]);
                if (list[i].selectedBillingMethod == true){
                    submissionVM.bindData.paymentDetails.selectedPaymentInstrument_EY.value = list[i].publicID;  
                }
            }
            /*$scope.addCreditCardInstrument = false;
            $scope.resetPaymentInstrument(null);*/
            updateLoadIframeUrl(false);
            updateAddCreditCardInstrument(false);
                ModalNextProvider.showAlert({
                    title: messages.paymentStatus,
                    message: messages.paymentAddedSuccessfully,
                    status: 'info',
                    icon: 'mi-error-outline',
                    confirmButtonText: commonMessages.ok
                }).catch(_.noop);

        }).catch(() => {
                ModalNextProvider.showAlert({
                    title: messages.paymentStatus,
                    message: messages.paymentAddFailure,
                    status: 'error',
                    icon: 'mi-error-outline',
                    confirmButtonText: commonMessages.ok
                }).catch(_.noop);
        });
    };

     /**Add Bank PaymentInstrument */
    const addBankPaymentInstrument   = () => {

        if (!(submissionVM.bindData.paymentDetails.bankAccountData.aspects.valid && submissionVM.bindData.paymentDetails.bankAccountData.aspects.subtreeValid)) {
            ModalNextProvider.showAlert({
                title: messages.paymentStatus,
                message: messages.bankdetailsEmptyError,
                status: 'error',
                icon: 'mi-error-outline',
                confirmButtonText: commonMessages.ok
            }).catch(_.noop);
            return;
        }
        LoadSaveService.addPaymentInstrument_EY(submissionVM.value, submissionVM.bindData.paymentDetails.value, authHeader).then(list => {
            //paymentList = [];
            updatePaymentList(list);            
            for(var i=0; i<list.length; i++){
                //paymentList.push(list[i]);
                if (list[i].selectedBillingMethod == true){
                    submissionVM.bindData.paymentDetails.selectedPaymentInstrument_EY.value = list[i].publicID;
                }
            }
            /*$scope.addCreditCardInstrument = false;
            $scope.resetPaymentInstrument(null);*/
            updateAddBankInstrument(false);
            /*ModalService.showInfo(
                'quoteandbind.controllers.PaymentDetailsCtrl.Payment Status',
                'quoteandbind.controllers.PaymentDetailsCtrl.Payment Add Success'
            );*/
        }).catch(() => {
            ModalNextProvider.showAlert({
                title: messages.paymentStatus,
                message: messages.paymentAddFailure,
                status: 'error',
                icon: 'mi-error-outline',
                confirmButtonText: commonMessages.ok
            }).catch(_.noop);
        });
    };

     /**Add Bank PaymentInstrument */
    const cancelBankPaymentInstrument   = () => {
        updateAddBankInstrument(false);
    };

    const handleBankAccountTypeChange = useCallback((value) => {
        submissionVM.bindData.paymentDetails.bankAccountData.bankAccountType.value = value;
        updateWizardData(submissionVM);
    }, [submissionVM, updateWizardData]);

    /**Get iFrame URL */
    const getIframeUrl  = () => {
            /*$scope.modeOfRec = submissionVM.bindData.paymentDetails.creditCardData.modeOfReceiving_EY ?
            submissionVM.bindData.paymentDetails.creditCardData.modeOfReceiving_EY.value:
            modeOfReceivingTypelist.getCode('paperformemail');*/
            updateLoadIframeUrl(false);
            var modeOfPayment = submissionVM.bindData.paymentDetails.creditCardData.modeOfReceiving_EY.value
            && submissionVM.bindData.paymentDetails.creditCardData.modeOfReceiving_EY.value.code ? submissionVM.bindData.paymentDetails.creditCardData.modeOfReceiving_EY.value.code : 'spokenoverphone'
            LoadSaveService.getURL_EY(submissionVM.value,modeOfPayment, authHeader).then(paymentUrl_EY => {
            updateiFrameUrl(paymentUrl_EY);
            var index = paymentUrl_EY.indexOf('?');
            updateMonURL(paymentUrl_EY.substring(0, index));
            updateLoadIframeUrl(true);
            updateAddCreditCardInstrument(true);
            }).catch(() => {
                ModalNextProvider.showAlert({
                    title: messages.paymentStatus,
                    message: messages.paymentAddFailure,
                    status: 'error',
                    icon: 'mi-error-outline',
                    confirmButtonText: commonMessages.ok
                }).catch(_.noop);
                /*ModalService.showError(
                    'quoteandbind.controllers.PaymentDetailsCtrl.Payment Status',
                    'quoteandbind.controllers.PaymentDetailsCtrl.Payment Add Failure'
                );
                $scope.url =  '';
                $scope.resetPaymentInstrument(null);
                $scope.addCreditCardInstrument = false;*/
                updateLoadIframeUrl(false);
                updateAddCreditCardInstrument(false);
                updateiFrameUrl('');
            });
    };

    const addPaymentInstrument = () => {
        updateAddCreditCardInstrument(false);
        updateAddBankInstrument(false);
        if(submissionVM.bindData.paymentDetails.paymentMethod.value === 'Preauthorized Credit Card') {
            if(submissionVM.bindData.paymentDetails.creditCardData.value === undefined){
                submissionVM.bindData.paymentDetails.creditCardData.value = {};
            }
            updateAddBankInstrument(false);
            getIframeUrl();
            updateAddCreditCardInstrument(true);
        } else if(submissionVM.bindData.paymentDetails.paymentMethod.value === 'Preauthorized Bank Account'){
            if(submissionVM.bindData.paymentDetails.bankAccountData.value === undefined){
                submissionVM.bindData.paymentDetails.bankAccountData.value = {};
            }
            updateAddBankInstrument(true);
            updateAddCreditCardInstrument(false);
        }
    };

    //~ down payment code changes end

    const isModelValid = useCallback(() => {
        const policyNumber = _.get(submissionVM, 'bindData.policyNumber.value');
        if (policyNumber !== undefined) {
            return true;
        }
        const paymentMethod = _.get(submissionVM, 'bindData.paymentDetails.paymentMethod.value');
        const bankAccountData = _.get(submissionVM, 'bindData.paymentDetails.bankAccountData', {});
        const creditCardData = _.get(submissionVM, 'bindData.paymentDetails.creditCardData', {});

        const paymentVM = paymentMethod === 'wire' ? bankAccountData : creditCardData;
        if (!_.isEmpty(paymentVM)) {
            return paymentVM.aspects.valid;
        }
        return true;
    }, [submissionVM]);

    const searchBankInstituteEY = () => {
        updateInstituteList([]);
        LoadSaveService.searchBankInstitute_EY(submissionVM.value,instituteNumber, "", authHeader)
            .then((list) => {
                /*for(var i=0; i<list.length; i++){
                    instituteList.push(list[i]);
                }*/
                updateInstituteList(list);
            })
            .catch((error) => {
                ModalNextProvider.showAlert({
                    title: messages.instituteSearchError,
                    message: messages.instituteSearchErrorDetails,
                    status: 'error',
                    icon: 'mi-error-outline',
                    confirmButtonText: commonMessages.ok
                }).catch(_.noop);
            });
    };

    const handleInstituteNumberChange = (value) => {
        setInstituteNumber(value);
    }


    const renderCreditCardTableTable = () => {
        const noRecordsMessage = 'No records found';
        return (
            <>
                <div>
                    <iframe
                        id="monerisFrame"
                        title="moneris payment"
                        className={styles.gwMonerisPayment}
                        frameBorder="0"
                        allowFullScreen
                        width="100%"
                        height="100%"
                        //src="https://www.youtube.com"
                        src={iframeUrl}
                        //src="https://esqa.moneris.com/HPPtoken/index.php?id=htB4HNFH85X9F7S&pmmsg=true&css_body=background:white;&css_textbox=border-width:2px;margin-bottom:10px;&css_textbox_pan=width:140px;&css_input_label=float:left;padding-right:10px;width:200px;&pan_label=Credit Card Number&exp_label=Expiry Date(MMYY)&&enable_exp=1&css_textbox_exp=width:40px;&display_labels=1"
                    />
                </div>
            </>
        );
    };

    const handleCreditCardModeChange = useCallback(
        (value) => {
            submissionVM.bindData.paymentDetails.creditCardData.modeOfReceiving_EY.value = value;
            updateAddBankInstrument(false);
            getIframeUrl();
            updateAddCreditCardInstrument(true);
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData]
    );

    useEffect(() => {
        getUpdatedPremium();
        if(submissionVM.bindData.paymentPlans && submissionVM.bindData.paymentPlans.value && submissionVM.bindData.paymentPlans.value.length == 1 ){
            _.set(submissionVM, 'bindData.selectedPaymentPlan', submissionVM.bindData.paymentPlans.value[0].billingId);
        }
        registerComponentValidation(isModelValid);
    }, [registerComponentValidation, isModelValid]);

    
    const handleCancel = useCallback(() => {
        return isComponentValid ? submissionVM : wizardSnapshot;
    }, [isComponentValid, submissionVM, wizardSnapshot]);

    const generateSigningPackage = () => {
       setShowSigningPackage(true)
    }

    const cancelPackageDetails = () => {
        setShowSigningPackage(false)
    }

    const savePackageDetails = () => {
        updateIsLoading(true);
        LoadSaveService.generateSigningPackageDetails(submissionVM.value, authHeader)
        .then((response) => {
            const newSubmissionVM = viewModelService.clone(submissionVM);
            _.set(newSubmissionVM, 'lobData.value', _.get(response, 'lobData'))
            updateWizardData(newSubmissionVM);
            setShowSigningPackage(false)
            updateIsLoading(false);
        })

    }

    const generateActualPackage = () => {
        updateIsLoading(true);
        LoadSaveService.generateSigningPackageDetails(submissionVM.value, authHeader)
            .then((response) => {
                const newSubmissionVM = viewModelService.clone(submissionVM);
                _.set(newSubmissionVM, 'lobData.value', _.get(response, 'lobData'))
                updateWizardData(newSubmissionVM);
                setShowSigningPackage(false)
                updateIsLoading(false);
            });

    };

    const generateSignPackageDocument = () => {
        updateIsLoading(true);
        LoadSaveService.generateSigningPackageDocumentPortal(submissionVM.value, submissionVM.baseData.isIssuanceJob.value, authHeader)
            .then((response) => {
                updateIsLoading(false);
                if(response.publicID && response.sessionID){
                    var downloadUrl = DocumentPageService.downloadDocument(
                        response.publicID,
                        response.sessionID
                    );
                    window.open(downloadUrl, '_blank');
                } 
                else{
                    ModalNextProvider.showAlert({
                        title: 'Unable to generate document',
                        message: 'Problem occured while generating document. Please try again later',
                        status: 'error',
                        icon: 'mi-error-outline',
                        confirmButtonText: 'Ok'
                    }).catch(_.noop);
                }
            });

    };

    const validatePaymentMethod = () => {
        if(submissionVM.bindData.paymentDetails.paymentMethod && (submissionVM.bindData.paymentDetails.paymentMethod.value == 'Preauthorized Bank Account' || submissionVM.bindData.paymentDetails.paymentMethod.value == 'Preauthorized Credit Card')){
            const paymentListData = submissionVM.bindData.paymentDetails.paymentMethod && submissionVM.bindData.paymentDetails.paymentMethod.value === 'Preauthorized Credit Card' ? paymentList.filter(payment => payment.paymentMethod === 'preauthorizedCC_EY') : paymentList.filter(payment => payment.paymentMethod === 'ach')
            if(!paymentListData.length > 0){
                return true;
            }
        }
        else if (submissionVM.bindData.paymentDetails.billingMethod_EY && submissionVM.bindData.paymentDetails.billingMethod_EY.value !== 'Agency Bill') {
            if (submissionVM.bindData.paymentDetails.paymentMethod && submissionVM.bindData.paymentDetails.paymentMethod.value) {
                return false;
            } else {
                return true;
            }
        } else {
            return false;
        }
    };

    const isWitdrawalRequired = () => {
        if(submissionVM.baseData.periodStatus.value.code !== 'Draft') {
            let monthlyPaymentId = submissionVM.bindData.paymentPlans && submissionVM.bindData.paymentPlans.value ? submissionVM.bindData.paymentPlans.value.filter((i)=>{return i.name == "Monthly Plan"}) : []
            monthlyPaymentId = monthlyPaymentId.length > 0 ? monthlyPaymentId[0].billingId : '';

        return submissionVM.bindData.selectedPaymentPlan && submissionVM.bindData.selectedPaymentPlan.value == monthlyPaymentId
        }
        
    }

    const getWithdrawValidation =() => {
        if(submissionVM.bindData.paymentDetails.billingMethod_EY && submissionVM.bindData.paymentDetails.billingMethod_EY.value == 'Agency Bill' || !isWitdrawalRequired()){
            return true
        }
        return (submissionVM.bindData.paymentDetails.withdrawDay_EY && submissionVM.bindData.paymentDetails.withdrawDay_EY.value)
    }

    const getVisibilityCheckForReferToUW =() => {
        if(!isComponentValid || validatePaymentMethod() || !getWithdrawValidation() || (_.isEmpty(submissionVM.bindData.selectedPaymentPlan.value))) {
            return true
        } 
        return false
    }

    const overrideProps = {
        '@field': {
            showOptional: true,
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        monthlyPremium: {
            value: avgMonthlypremium
        },
        totalPremium: {
            value: totalpremium
        },
        paymentOptions: {
            //  onValueChange: handlePaymentOptionChange
        },

        billingMethod: {
            availableValues: getBillingAvailableValues(),
            onValueChange: handleBillingOptionChange
        },
        creditCardPayment: {
            content: renderCreditCardTableTable(),
            visible: loadIframeUrl
        },
        paymentMethod: {
            availableValues: getPaymentMethodList(),
            onValueChange: handlePaymentOptionEyChange,
            visible: submissionVM.bindData.paymentDetails && submissionVM.bindData.paymentDetails.billingMethod_EY && submissionVM.bindData.paymentDetails.billingMethod_EY.value !== 'Agency Bill'
        },
        addPayment: {
            onClick: addDownPaymentItem,
            content: paymentBtn.getLabel()
        },
        dayOfMonth: {
            availableValues: getWithdrawalDayOfMonth(),
            required: isWitdrawalRequired(),
            visible:isWitdrawalRequired(),
            showRequired: isWitdrawalRequired()
           // onValueChange: handleWithdrawDayOfMonthChange
        },
        paymentDataTable: {
            data: submissionVM.bindData.paymentDetails && submissionVM.bindData.paymentDetails.downPayment_EY ?
                submissionVM.bindData.paymentDetails.downPayment_EY.children: []
        },
        bankAccountHolder: {
            value: _.get(submissionVM, 'baseData.primaryNamedInsured.displayName.value')
        },

        /* questionSets: {
            path: LOB_PATH[lobCode],
            visible: showSigningPackage
        },
        packageDetailsButtonContainer: {
            visible: showSigningPackage
        }, */
        /* generateSigningPackageSummary: {
            visible: !showSigningPackage
        }*/
        // deletePackage: {
        //     disabled: submissionVM.bindData.paymentDetails.downPayment_EY.children.length === 1
        // }
        addPayUsing: {
            onClick: addPaymentInstrument
        },
        payUsingDataTable: {
            data: submissionVM.bindData.paymentDetails && submissionVM.bindData.paymentDetails.paymentMethod && submissionVM.bindData.paymentDetails.paymentMethod.value === 'Preauthorized Credit Card' ? paymentList.filter(payment => payment.paymentMethod === 'preauthorizedCC_EY') : paymentList.filter(payment => payment.paymentMethod === 'ach')
            //data: paymentList
        },
        CardPaymentDiv: {
            visible: submissionVM.bindData.paymentDetails && submissionVM.bindData.paymentDetails.billingMethod_EY && submissionVM.bindData.paymentDetails.paymentMethod && submissionVM.bindData.paymentDetails.billingMethod_EY.value !== 'Agency Bill' && submissionVM.bindData.paymentDetails.paymentMethod
                    && (submissionVM.bindData.paymentDetails.paymentMethod.value === 'Preauthorized Credit Card' || submissionVM.bindData.paymentDetails.paymentMethod.value === 'Preauthorized Bank Account')

        },
        paymentCheckBox: {
            option: generateDataForRadioButton,
            value: submissionVM.bindData.paymentDetails && submissionVM.bindData.paymentDetails.selectedPaymentInstrument_EY ? submissionVM.bindData.paymentDetails.selectedPaymentInstrument_EY.value : undefined,
            onValueChange: handleValueChange
        },
        MonerisCreditCardDiv: {
            visible: addCreditCardInstrument
        },
        bankAccountDetailsCard: {
            visible: addBankInstrument
        },
        searchInstitueInput:{
            value:instituteNumber
        },
        SearchInstituteButton:{
            onClick: searchBankInstituteEY
        },
        bankInstitueDataTable: {
            data: instituteList
        },
        instituteCheckBox: {
            option: generateDataForInstitureRadioButton,
            value: selectedBankValue,
            onValueChange: handleInstitueValueChange
        },
        CrediCardModeofPayToggle: {
            onValueChange: handleCreditCardModeChange
        },
        validateCreditCardButton: {
            disabled: isMonerisSubmitted
        },
        paymentPlansList: {
            productCode: submissionVM.baseData.productCode.value,
            periodStatus: submissionVM.baseData.periodStatus.value.code,
            disabled: submissionVM.baseData.productCode.value === 'BusinessAuto' && _.filter(submissionVM.lobData.businessAuto.coverables.vehicles.value, {vehicleType:'PrivatePassenger_EY'}).length > 0,
            disableMonthlyPay: (submissionVM.bindData.paymentDetails && submissionVM.bindData.paymentDetails.billingMethod_EY && submissionVM.bindData.paymentDetails.billingMethod_EY.value === "Direct Bill") && (submissionVM.bindData.paymentDetails && submissionVM.bindData.paymentDetails.paymentMethod.value == "Invoiced"),
            disableOnePay: (submissionVM.bindData.paymentDetails && submissionVM.bindData.paymentDetails.billingMethod_EY && submissionVM.bindData.paymentDetails.billingMethod_EY.value === "Direct Bill") && 
            (submissionVM.bindData.paymentDetails && (submissionVM.bindData.paymentDetails.paymentMethod.value == "Preauthorized Credit Card" || submissionVM.bindData.paymentDetails.paymentMethod.value == "Preauthorized Bank Account")) 
        },
        signingPackageButton:{
            visible: checkPermission('gensignpackagedoc_EY'),
            disabled: !isComponentValid || validatePaymentMethod() || !getWithdrawValidation() || (validationIssues.length > 0 && !ispaymentIssue) || (_.isEmpty(submissionVM.bindData.selectedPaymentPlan.value))
        },
        underWritingIssues: {
            underwritingIssues: underwritingIssues,
            blockQuote: findBlockingPoint(),
            quoteID: submissionVM.quoteID.value,
            filterUWIssuesInCustomOffering,
            job:submissionVM.baseData.jobType.value,
            submissionVM,
            updateWizardData,
            referButtonVisible : getVisibilityCheckForReferToUW()
        }
    };

    const readValue = useCallback(
        (id, path) => {
            return readViewModelValue(metadata.pageContent, submissionVM, id, path, overrideProps);
        },
        [submissionVM, overrideProps]
    );


    const resolvers = {
        resolveCallbackMap: {
            getDataTableCell: getDataTableCell,
            deleteDownPayment: deleteDownPayment,
            editDownPayment: editDownPayment,
            generateSigningPackage: generateSigningPackage,
            savePackageDetails: savePackageDetails,
            generateActualPackage: generateActualPackage,
            generateSignPackageDocument: generateSignPackageDocument,
            cancelPackageDetails: cancelPackageDetails,
            getPayUsingDataTableCell: getPayUsingDataTableCell,
            doMonerisSubmit: doMonerisSubmit,
            handleInstituteNumberChange: handleInstituteNumberChange,
            addBankPaymentInstrument: addBankPaymentInstrument,
            handleBankAccountTypeChange: handleBankAccountTypeChange,
            cancelBankPaymentInstrument: cancelBankPaymentInstrument,
        },
        resolveComponentMap: { questionset: QuestionSetComponent }
    };

    return isLoading ? (
        <Loader loaded={!isLoading} />
    ) : (
            <WizardPage
                showNext={checkPermission('issue')}
                nextLabel={messages.issuePolicy}
                onNext={handleNext}
                disableNext={ !isComponentValid || validatePaymentMethod() || !getWithdrawValidation() || (validationIssues.length > 0 && !ispaymentIssue) || (_.isEmpty(submissionVM.bindData.selectedPaymentPlan.value))}
                onCancel={handleCancel}
            >
                <ViewModelForm
                    uiProps={metadata.pageContent}
                    model={submissionVM}
                    onModelChange={updateWizardData}
                    overrideProps={overrideProps}
                    resolveValue={readValue}
                    callbackMap={resolvers.resolveCallbackMap}
                    componentMap={resolvers.resolveComponentMap}
                    classNameMap={styles}
                />
            </WizardPage>
        );
}

PaymentDetailsPage.propTypes = wizardProps;
export default PaymentDetailsPage;
